/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesRole } from './WebApiModelsEnumerationTypesRole';
import {
    WebApiModelsEnumerationTypesRoleFromJSON,
    WebApiModelsEnumerationTypesRoleFromJSONTyped,
    WebApiModelsEnumerationTypesRoleToJSON,
} from './WebApiModelsEnumerationTypesRole';

/**
 * 
 * @export
 * @interface WebApiCompanyDtoCompanyAddUserDto
 */
export interface WebApiCompanyDtoCompanyAddUserDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyAddUserDto
     */
    inviteEmail?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesRole}
     * @memberof WebApiCompanyDtoCompanyAddUserDto
     */
    role?: WebApiModelsEnumerationTypesRole;
}

/**
 * Check if a given object implements the WebApiCompanyDtoCompanyAddUserDto interface.
 */
export function instanceOfWebApiCompanyDtoCompanyAddUserDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCompanyDtoCompanyAddUserDtoFromJSON(json: any): WebApiCompanyDtoCompanyAddUserDto {
    return WebApiCompanyDtoCompanyAddUserDtoFromJSONTyped(json, false);
}

export function WebApiCompanyDtoCompanyAddUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCompanyDtoCompanyAddUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'inviteEmail': !exists(json, 'inviteEmail') ? undefined : json['inviteEmail'],
        'role': !exists(json, 'role') ? undefined : WebApiModelsEnumerationTypesRoleFromJSON(json['role']),
    };
}

export function WebApiCompanyDtoCompanyAddUserDtoToJSON(value?: WebApiCompanyDtoCompanyAddUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'inviteEmail': value.inviteEmail,
        'role': WebApiModelsEnumerationTypesRoleToJSON(value.role),
    };
}

